import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-100 existing-catalog" }
const _hoisted_2 = { class: "w-100 font-weight-bold" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-Open" }, null, -1)

import { useChannelCreatorState } from "@ChannelCreator/composables/useChannelCreator";
import type { catalog as Catalog } from "@medapro-types/ChannelCreator/store/channel-creator-store";
import TextWithFallbackDisplay from "@common/components/TextWithFallbackDisplay.vue";
import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { naturalSort } from "@util/naturalSort";
import { computed, onMounted, reactive, watch } from "vue";
import ManageCatalogs from "../../ManageCatalogs.vue";

//#region Props & Emits
type ViewModel = {
  selectedCatalogId: string | null;
  selectedCatalogName: string | null;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ExistingCatalogExternal',
  props: {
    selectedExistingCatalogId: {}
  },
  emits: ["update:selectedExistingCatalogId", "setCatalogName"],
  setup(__props: any, { emit: emits }) {

const props = __props;




//#endregion

//#region Store
const { primaryLanguage } = useContentLanguages();
const { catalogs } = useChannelCreatorState();

//#endregion

//#region ViewModel
const vm = reactive<ViewModel>({
  selectedCatalogId: "",
  selectedCatalogName: ""
});

//#endregion

//#region Computed
const { primaryLanguageCode } = useContentLanguages();

const sortedCatalogs = computed(() => naturalSort(catalogs.value, (elem) => elem[primaryLanguageCode.value]?.name));

const selectedSourceCatalog = computed(() => catalogs.value.find((c) => c[primaryLanguageCode.value]?.catalogId === vm.selectedCatalogId));
//#endregion

//#region Methods
const getCatalogName = (catalog: Record<string, Catalog>) => {
  const lang = primaryLanguage.value;
  if (!lang) return "";

  const name = catalog[lang.languageCode]?.name;
  if (name) return name;

  if (lang.fallbackLanguageCode) {
    return catalog[lang.fallbackLanguageCode]?.name || "";
  }

  return "";
};

const selectCatalogId = (catalog: Record<string, Catalog>) => {
  vm.selectedCatalogId = catalog[primaryLanguageCode.value].catalogId;
  vm.selectedCatalogName = getCatalogName(catalog);
};

const handleSelectedCatalog = (selectedSourceCatalogId: string) => {
  vm.selectedCatalogId = selectedSourceCatalogId;
};
//#endregion

//#region Watchers
watch(
  () => vm.selectedCatalogId,
  (nv) => {
    emits("update:selectedExistingCatalogId", nv);
  }
);

watch(
  () => vm.selectedCatalogName,
  (nv) => {
    emits("setCatalogName", nv);
  }
);

//#endregion

//#region Lifecycle
onMounted(() => {
  vm.selectedCatalogId = props.selectedExistingCatalogId;
});
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _component_b_btn = _resolveComponent("b-btn")!
  const _directive_b_modal = _resolveDirective("b-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("GenerateCatalogFromTextFile.ExistingCatalog")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_b_dropdown, { class: "dropdown-default grow mr-2" }, {
        "button-content": _withCtx(() => [
          _createVNode(TextWithFallbackDisplay, {
            source: selectedSourceCatalog.value,
            language: _unref(primaryLanguage),
            field: "name"
          }, null, 8, ["source", "language"])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedCatalogs.value, (catalog) => {
            return (_openBlock(), _createBlock(_component_b_dropdown_item, {
              key: catalog[_unref(primaryLanguageCode)].catalogId,
              active: catalog[_unref(primaryLanguageCode)].catalogId === vm.selectedCatalogId,
              onClick: ($event: any) => (selectCatalogId(catalog))
            }, {
              default: _withCtx(() => [
                _createVNode(TextWithFallbackDisplay, {
                  source: catalog,
                  language: _unref(primaryLanguage),
                  field: "name"
                }, null, 8, ["source", "language"])
              ]),
              _: 2
            }, 1032, ["active", "onClick"]))
          }), 128))
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_b_btn, { class: "btn-icon mono" }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })), [
        [
          _directive_b_modal,
          void 0,
          void 0,
          { "select-source-catalog": true }
        ]
      ])
    ]),
    _createVNode(ManageCatalogs, {
      "modal-name": "select-source-catalog",
      "included-catalog-types": [0, 1],
      "dialog-mode": "open",
      onSelectedCatalog: handleSelectedCatalog
    })
  ]))
}
}

})